const paymentsConstants = {
  flows: {
    pay: {
      withRecurrenceSelector: 'withRecurrenceSelector',
      withoutRecurrenceSelector: 'withoutRecurrenceSelector',
    },
  },
  flowParams: {
    withCommunity: 'withCommunity',
  },
};

export default paymentsConstants;
